import { ContentPreview } from '@opallabs/periodic/src/ContentPreview'
import { GetContentByIDV2Return } from '../../../helpers/types'
import { validations } from '../../../helpers/validations'
import { styles } from '../styles'

export interface Props {
  display: string
  getContentByIdV2: (id: number) => Promise<GetContentByIDV2Return>
  isPresenting: boolean
  onRefreshedAtChange: (val: string, dest: string) => void
  onSnapshotUrlChange: (val: string, dest: string) => void
  onTweetUrlChange: (val: string, dest: string) => void
  readOnly: boolean
  refreshedAt: string
  snapshotUrl: string
  tweetUrl: string
}

export const Stream: React.FC<Props> = ({
  display = 'mobileStream',
  getContentByIdV2,
  isPresenting,
  onRefreshedAtChange,
  onSnapshotUrlChange,
  onTweetUrlChange,
  readOnly,
  refreshedAt,
  snapshotUrl,
  tweetUrl,
}) => (
  <div>
    <ContentPreview
      display={display}
      embeddedUrl={tweetUrl}
      embeddedUrlRegex={validations.twitterUrlValidation}
      isPresenting={isPresenting}
      getContentByIdV2={getContentByIdV2}
      onEmbeddedUrlChange={(val: string) => onTweetUrlChange(val, 'tweet_url')}
      onRefreshChange={(val: string) =>
        onRefreshedAtChange(val, 'refreshed_at')
      }
      onSnapshotUrlChange={(val: string) =>
        onSnapshotUrlChange(val, 'snapshot_url')
      }
      overrideStyles={{ input: styles.getInputStyles(display) }}
      readOnly={readOnly}
      refreshedAt={refreshedAt}
      snapshotUrl={snapshotUrl}
    />
  </div>
)
